module.exports = __webpack_public_path__ + "static/img/top.31009c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/top.jpg
// module id = SXi6
// module chunks = 11